module.exports = __webpack_public_path__ + "img/footerbackground@2x.075f4497.png";